module.exports = __webpack_public_path__ + "static/media/performance-analysismarketing.c02057b9.svg";